/* eslint-disable @typescript-eslint/no-explicit-any */
import Image from "next/image";

import richTextRendererUtils from "@/utils/richTextRenderer";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Document, MARKS } from "@contentful/rich-text-types";
import { Stack, Typography } from "@mui/material";

import { styles } from "./styles";
import { KMVAppIncentiveSectionProps } from "./types";

export const KMVAppIncentiveSection: React.FC<KMVAppIncentiveSectionProps> = ({ title, description, qrCodeText, qrCodeImage }) => {
  return (
    <Stack
      bgcolor="#FFB206"
      gap={{ xs: 6, lg: 7 }}
      py={{ xs: 6, sm: 6, md: 10, lg: 10 }}
      px={{ xs: 3, sm: 3, md: 4, lg: 10 }}
      flexDirection={{ xs: "column", sm: "column", md: "row", lg: "row" }}
    >
      <Stack>
        <Stack spacing="20px" px={2} py="20px" css={styles.card_qrcode}>
          <Typography component="div" fontWeight={500} fontSize={14} textAlign="center">
            {documentToReactComponents(qrCodeText as Document, richTextRendererUtils)}
          </Typography>

          <Image src={qrCodeImage} alt="QR Code" width={141} height={147} />
        </Stack>
      </Stack>

      <Stack spacing={2}>
        <Typography component="div" fontSize={36} fontWeight={600}>
          {documentToReactComponents(title as Document, {
            renderMark: {
              [MARKS.BOLD]: (text: any) => (
                <Typography component="span" style={{ fontWeight: 600, fontSize: 36 }}>
                  {text}
                </Typography>
              )
            }
          })}
        </Typography>

        <Typography component="div" fontSize={16}>
          {documentToReactComponents(description as Document, richTextRendererUtils)}
        </Typography>
      </Stack>
    </Stack>
  );
};
